import SectionMaster from '../../features/masters/SectionMaster'

function SectionPage() {
  return (
    <SectionMaster />
  )
}

export default SectionPage;